/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MyLibraryCandidateViewModel } from "../types/MyLibraryCandidateViewModel.ts";
import { eEnrollmentStatusSchema } from "./eEnrollmentStatusSchema.ts";

export const myLibraryCandidateViewModelSchema = z.object({
  personId: z.optional(z.number().int().describe("ID da pessoa candidata.")),
  personName: z.string().describe("Nome completo da pessoa.").nullish(),
  email: z.string().describe("E-mail da pessoa, em minúsculas.").nullish(),
  classStudentId: z.optional(
    z.number().int().describe("ID da turma da matrícula."),
  ),
  classStudentName: z
    .string()
    .describe("Nome da turma na cultura solicitada.")
    .nullish(),
  enrollmentStatus: z.optional(
    z
      .lazy(() => eEnrollmentStatusSchema)
      .describe(
        "1 = PaymentSelection | 2 = PaymentPending | 3 = ApprovalPending | 4 = Approved | 5 = Activating | 6 = Active | 7 = Transferred | 8 = TransferredInRegistration | 9 = Canceled | 10 = CanceledInRegistration | 11 = Rejected | 12 = FinishedWithPendencies | 13 = Finished | 14 = FinishedWithMonograph | 15 = FinishedWithCertificate | 16 = Blocked | ",
      ),
  ),
  enrollmentStatusName: z
    .string()
    .describe(
      "Descrição do status de matrícula já resolvida na cultura solicitada. No legado essa descrição era montada pela tela.",
    )
    .nullish(),
}) as unknown as ToZod<MyLibraryCandidateViewModel>;
